import React from "react";
import { Link } from "react-router-dom";
import { logoImage } from "../../../../assets";
export default function Headers() {
  return (
    <div className="main-bg">
      <header>
        <div className="container-fluid">
          <div className="logo">
            <Link onClick={() => sessionStorage.clear()} to="/login">
              <img src={logoImage} height="48px" />
            </Link>
            <dt></dt>
          </div>
        </div>
      </header>
    </div>
  );
}
